/**
 * useCurrentTime
 * ──────────────────────────────────────────────────────────────────────
 * Returns the current Date, re-rendering every `intervalMs` (default 60s)
 * so the Calendar's red "current time" line stays accurate in real time
 * (Edit 2 of scheduler_edits_v2.md).
 */
import { useEffect, useState } from 'react';

export const useCurrentTime = (intervalMs = 60000) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
};

export default useCurrentTime;
